<template>
  <card-item card="item_shop" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Представители",
          component: () => import("./Users"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>